module.exports = __webpack_public_path__ + "static/media/10.5e58f2b6.jpg";